var exports = {
  "kL": "GuildBoostTab.module__container___VXRHTU",
  "dc": "GuildBoostTab.module__spinnerContainer___VXRHTU",
  "uW": "GuildBoostTab.module__section___VXRHTU",
  "Ci": "GuildBoostTab.module__levelsHeading___VXRHTU",
  "bh": "GuildBoostTab.module__slotNote___VXRHTU",
  "SU": "GuildBoostTab.module__muted___VXRHTU",
  "o1": "GuildBoostTab.module__actions___VXRHTU",
  "Gu": "GuildBoostTab.module__boosters___VXRHTU",
  "rq": "GuildBoostTab.module__booster___VXRHTU",
  "my": "GuildBoostTab.module__avatar___VXRHTU",
  "UU": "GuildBoostTab.module__name___VXRHTU",
};

module.exports = exports;
